import axios, {AxiosResponse} from 'axios'
import {ITtn, TtnsQueryResponse} from './_models'
import {getConfig} from '../../../../../_metronic/i18n/Metronici18n'

const PRODS_URL = `${process.env.REACT_APP_API_PATH}/ttn`

const API = process.env.REACT_APP_API_PATH
const CRAUZER_BASE = `${process.env.REACT_APP_HTTP}${process.env.REACT_APP_URL}${API}`

const getProducts = (query: string): Promise<TtnsQueryResponse> => {
  return axios.get(`${PRODS_URL}?${query}`).then((d: AxiosResponse<TtnsQueryResponse>) => d.data)
}

const getProductsByParcel = (parcelCode: string): Promise<ITtn | undefined> => {
  return axios
    .get(`${PRODS_URL}?parcel.code=${parcelCode}`)
    .then((response: AxiosResponse<ITtn>) => response.data)
}

const getTTNStatuses = (parcelCode: string): Promise<any | undefined> => {
  const {selectedLang} = getConfig()
  return axios
    .get(`${CRAUZER_BASE}/ttns/status-logs/${parcelCode}`, {
      headers: {
        'Accept-Language': selectedLang,
      },
    })
    .then((response: AxiosResponse<any>) => response.data)
}

export {getProducts, getProductsByParcel, getTTNStatuses}
